export default {
  SET_CONTRACT_VALUES: 'SET_CONTRACT_VALUES',
  SET_CONTRACT_INFO: 'SET_CONTRACT_INFO',
  SET_DATE: 'SET_DATE',
  SET_DISPLAY_DATE: 'SET_DISPLAY_DATE',
  SET_DURATION: 'SET_DURATION',
  SET_TYPE: 'SET_TYPE',
  SET_BOND_VALUES: 'SET_BOND_VALUES',
  SET_USERS: 'SET_USERS' ,
  SET_WARRANTY: 'SET_WARRANTY',
  
  CHECK_INSURANCE: 'CHECK_INSURANCE',
  CHECK_INSURANCE_SUCCESSFULLY_CREATED: 'CHECK_INSURANCE_SUCCESSFULLY_CREATED',
  CHECK_INSURANCE_SUCCESSFULLY_CHECKED: 'CHECK_INSURANCE_SUCCESSFULLY_CHECKED',
  
  
  TIMEOUT_INSURANCE_CHECK: 'TIMEOUT_RETRY_INSURANCE_CHECK',
  RETRY_INSURANCE_CHECK: 'RETRY_INSURANCE_CHECK',

  ANNOUNCE_PROPERTY: 'ANNOUNCE_PROPERTY',

  SET_PROPOSITION_ID: 'SET_PROPOSITION_ID',
  SET_CONTRACT_ID: 'SET_CONTRACT_ID',

  SET_PROPERTIES: 'SET_PROPERTIES',
  SET_OWNED_PROPERTIES: 'SET_OWNED_PROPERTIES',
  SET_INITIAL_FETCH: 'SET_INITIAL_FETCH',
}